import { BrowserRouter, Route, Routes } from "react-router-dom";
import SiteLayout from "./components/SiteLayout";
import AboutPage from "./pages/AboutPage";
import DetailsRsvpPage from "./pages/DetailsRsvpPage";
import HomePage from "./pages/HomePage";
import RegistryPage from "./pages/RegistryPage";
import TravelPage from "./pages/TravelPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<SiteLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/details" element={<DetailsRsvpPage />} />
          <Route path="/travel" element={<TravelPage />} />
          <Route path="/registry" element={<RegistryPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
